<template>
    <div class="modal">
        <span class="close" v-on:click="$emit('close')">x</span>
        <div class="modal-content">
            <h1 class="register-title">Registriraj se</h1>
            <span>Već imaš račun? <span class="login" v-on:click="$emit('showLoginModal')">Prijavi se &#10230;</span></span>
            <form id="registration" v-on:submit.prevent="register()" novalidate="true">
                <div class="form-field">
                    <input id="firstname" type="text" v-model="userToRegister.firstName" v-on:change="validateFirstName" />
                    <label for="firstname" v-bind:class="userToRegister.firstName ? 'field-filled' : ''">Ime*</label>
                    <div class="error" v-bind:style="{visibility: isFirstNameValid ? 'hidden' : 'visible'}">Ime ne smije biti prazno.</div>
                </div>
                <div class="form-field">
                    <input id="lastname" type="text" v-model="userToRegister.lastName" v-on:change="validateLastName" />
                    <label for="lastname" v-bind:class="userToRegister.lastName ? 'field-filled' : ''">Prezime*</label>
                    <div class="error" v-bind:style="{visibility: isLastNameValid ? 'hidden' : 'visible'}">Prezime ne smije biti prazno.</div>
                </div>
                <div class="form-field">
                    <input id="email" type="text" v-model="userToRegister.email" v-on:change="checkIfEmailExists()" />
                    <label for="email" v-bind:class="userToRegister.email ? 'field-filled' : ''">Email adresa*</label>
                    <div class="error" v-bind:style="{visibility: doesEmailExist || !isEmailValid ? 'visible' : 'hidden'}">{{doesEmailExist ? 'Upisana e-mail adresa već postoji.' : 'Upisana e-mail adresa nije valjana.'}}</div>
                </div>
                <div class="form-field"> 
                    <select id="birthyear" v-model="userToRegister.birthYear">
                        <option v-bind:value="null">-</option>
                        <option v-for="year in getYears()" v-bind:value="year" v-bind:key="year">
                            {{year}}
                        </option>
                    </select> 
                    <label for="birthyear" class="field">Godina rođenja</label>
                </div>
                <div class="form-field">
                    <input id="password" type="password" v-model="userToRegister.password" v-on:change="validatePassword" />
                    <label for="password" v-bind:class="userToRegister.password ? 'field-filled' : ''">Lozinka*</label>
                    <div class="error" v-bind:style="{display: isPasswordValid ? 'none' : 'block'}">Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.</div>
                </div>
                <div class="form-field">
                    <input id="repeatedpassword" type="password" v-model="repeatedPassword" v-on:change="validateRepeatedPassword" />
                    <label for="repeatedpassword" v-bind:class="repeatedPassword ? 'field-filled' : ''">Ponovljena lozinka*</label>
                    <div class="error" v-bind:style="{visibility: isRepeatedPasswordValid ? 'hidden' : 'visible'}">Upisane lozinke se ne poklapaju.</div>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="newsletterCheckbox" v-model="userToRegister.newsletterEnabled">
                    <label for="newsletterCheckbox">Rado bismo s tobom dijelili sve najvažnije informacije o konferenciji da budeš u toku. Nećemo te <i>spammat</i>, obećavamo!</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="gdprCheckbox" v-model="acceptedGdpr">
                    <label for="gdprCheckbox">Slažem se s </label><span class="terms" v-on:click="showGdprModal = true">uvjetima i odredbama.</span>
                </div>
                <button type="submit" class="button" value="submit" v-bind:disabled="!isFormValid() || isRegistering">REGISTRACIJA</button>
                <div class="error" v-bind:style="{visibility: !didRegistrationSucceed && isRegistrationOver ? 'visible' : 'hidden'}">
                    Registracija nije uspjela. Molimo Vas provjerite unesene podatke još jednom.
                </div>
                <div class="success" v-bind:style="{visibility: didRegistrationSucceed && isRegistrationOver ? 'visible' : 'hidden'}">
                    Registracija je uspjela. Provjeri e-mail i klikni na aktivacijski link da aktiviraš svoj račun.
                </div>
            </form>
        </div>
        <GdprModal v-if="showGdprModal" v-on:close="showGdprModal = false"/>
    </div>
</template>

<script>
    import { emailRegex } from '@/config';
    import GdprModal from '@/components/landing-page/GdprModal.vue';

    export default {
            name: 'RegistrationModal',
            data() {
                return {
                    userToRegister: {},
                    repeatedPassword: "",
                    acceptedGdpr: false,
                    showGdprModal: false,
                    isFirstNameValid: true,
                    isLastNameValid: true,
                    isPasswordValid: true,
                    isRepeatedPasswordValid: true,
                    isEmailValid: true,
                    doesEmailExist: false,
                    didRegistrationSucceed: true,
                    isRegistrationOver: false,
                    isRegistering: false,
                    appUrl: ""
                }
            },
            components: {
                GdprModal
            },
            methods: {
                getYears: function() {
                    let currentYear = new Date().getFullYear()
                    let years = [];
                    let startYear = 1950;

                    while (startYear <= currentYear)
                        years.push(startYear++);

                    return years.reverse();
                },
                validateFirstName: function() {
                    this.isFirstNameValid = this.userToRegister.firstName ? true : false;
                },
                validateLastName: function() {
                    this.isLastNameValid = this.userToRegister.lastName ? true : false;
                },
                checkIfEmailExists: function() {
                    if(!this.userToRegister.email || !emailRegex.test(this.userToRegister.email))
                    {
                        this.doesEmailExist = false;
                        this.isEmailValid = false;
                    }
                    else
                    {
                        this.isEmailValid = true;
                        this.$axios.get(`${this.$API_URL}/user/check-email`, {
                            params: {
                                email: this.userToRegister.email
                            }
                        }).then(response => {
                            this.doesEmailExist = response.data;
                        });
                    }
                },
                validatePassword: function() {
                    let pass = this.userToRegister.password;
                    this.isPasswordValid = pass && pass.length >= 8 && pass.toLowerCase() !== pass && /\d/.test(pass);
                },
                validateRepeatedPassword: function() {
                    this.isRepeatedPasswordValid = this.userToRegister.password === this.repeatedPassword;
                },
                isFormValid: function() {
                    return this.userToRegister.firstName && this.userToRegister.lastName && 
                        this.userToRegister.email && this.userToRegister.password && this.acceptedGdpr &&
                        this.isFirstNameValid && this.isLastNameValid && 
                        this.isPasswordValid && this.isRepeatedPasswordValid && 
                        this.isEmailValid && !this.emailExists;
                },
                register: function() {
                    if(this.isFormValid() && this.userToRegister.password === this.repeatedPassword)
                    {
                        this.isRegistering = true;
                        this.$axios.post(`${this.$API_URL}/user/register`, {
                            userToRegister: this.userToRegister,
                            appUrl: this.appUrl
                        }).then(() => {
                            this.didRegistrationSucceed = true;
                            this.isRegistering = false;
                            this.isRegistrationOver = true;
                            setTimeout(() => this.$emit('close'), 5000);
                        }).catch(() => {
                            this.didRegistrationSucceed = false;
                            this.isRegistering = false;
                            this.isRegistrationOver = true;
                            setTimeout(() => this.isRegistrationOver = false, 5000);
                        });
                    }
                }
            },
            created() {
                this.appUrl = `${window.location.protocol}//${window.location.host}`;
                this.userToRegister.birthYear = null;
                this.userToRegister.newsletterEnabled = false;
            },
            mounted() {
                document.body.classList.add('modal-open');
            },
            beforeDestroy() {
                document.body.classList.remove('modal-open');
            }
        }
</script>

<style scoped>
    .success {
        margin-bottom: 50px;
    }

    .modal-content {
        top: 25%;
        bottom: 0;
        position: absolute;
        padding-left: 20%;
        overflow-y: scroll;
    }

    form {
        padding-right: 40%;
    }

    .register-title {
        font-weight: 800;
        margin-bottom: 20px;
    }

    .login,
    .close {
        color: #30cec1;
    }

    .close {
        font-size: 64px;
        font-weight: 300;
        transform:scale(1.4,1);
        position: absolute;
        right: 10%;
        top: 10%;
        z-index: 2;
    }

    .login:hover,
    .close:hover {
        cursor: pointer;
    }

    #registration {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    #registration div {
        flex-basis: 35%;
        margin-right: 5%;
    }

    .terms {
        cursor: pointer;
        text-decoration: underline;
    }

    input,
    select {
        margin-top: 20px;
        border: none;
        background-color: #f9f9f9;
        border-bottom: 2px solid black;
        font-size: 20px;
        padding: 18px 0 5px 20px;
        width: 100%;
        outline: none;
    }

    input[type=checkbox] {
        width: auto;
    }

    select {
        appearance: none;
    }

    form > div {
        position: relative;
    }

    form > div.form-field > label {
        position: absolute;
        font-size: 16px;
        left: 20px;
        top: 34px;
        opacity: 0.7;
    }

    form > div.form-field input:focus + label,
    form > div.form-field select + label,
    form > div.form-field > label.field-filled {
        font-size: 14px;
        top: 22px;
        opacity: 0.6;
    }

    input:focus,
    select:focus {
        border-bottom-color: #30cec1;
    }

    #registration div.checkbox {
        margin-top: 5px;
        flex-basis: 80%;
    }

    #registration div.checkbox input {
        margin-right: 10px;
    }

    .button {
        margin-top: 20px;
        margin-right: 50%;
    }

    @media screen and (max-width: 1500px) {
        #registration div {
            flex-basis: 40%;
        }
    }

    @media screen and (max-width: 1270px) {
        #registration div {
            flex-basis: 45%;
        }
    }

    @media screen and (max-width: 1124px) {
        #registration div {
            flex-basis: 100%;
        }

        input,
        select {
            font-size: 24px;
        }

        #registration div.checkbox {
            padding-right: 20%;
        }
    }

    @media screen and (max-width: 768px) {
        .modal-content {
            top: 10%;
            height: 90%;
        }

        .register-title {
            flex-direction: column;
            align-items: flex-start;
        }

        #registration div.checkbox {
            flex-basis: 100%;
            padding-right: 0;
        }
    }

    @media screen and (max-width: 605px) {
        .close {
            top: 10%;
        }

        form {
            padding-right: 20%;
        }
    }

    @media screen and (max-width: 450px) {
        .close {
            top: 5%;
        }

        .modal-content {
            padding-left: 10%;
        }

        .error {
            font-size: 12px;
        }
    }
</style>